import Layout from 'antd/lib/layout';
import React, { useState } from 'react';
import { SidebarWrapper } from '../../../../components/sidebar-filters/SidebarWrapper';
import Typography from 'antd/lib/typography';
import { SidebarFiltersGroupCollapse } from '../../../../components/sidebar-filters/SidebarFiltersGroupCollapse';
import { ICreateSavedFilter } from '../../../../components/sidebar-filters/saved-filter/interface';
import { AGREEMENT_STATUSES_PAGE_CONST } from './constants';
import { IAgreementStatusesSidebarFilters, useAgreementStatusesSidebarFiltersContext } from './AgreementStatusesSidebarFiltersContext';
import { AgreementStatusesSidebarTabs } from './AgreementStatusesSidebarTabs';
import { SaveAgreementStatusesFiltersModal } from './SaveAgreementStatusesFilterModal';

interface IAgreementStatusesSidebarProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    totalRecords?: number;
    onFilterChange: (filter: IAgreementStatusesSidebarFilters) => void;
    gridComponent: React.ReactNode;
}

export const AgreementStatusesSidebar: React.FC<IAgreementStatusesSidebarProps> = ({
    collapsed,
    onCollapseChange,
    totalRecords,
    onFilterChange,
    gridComponent,
}) => {
    const {
        selectedSavedFilter,
        handleSavedFilterSelect,
        handleCreateSavedFilter,
        isCreateFilterLoading,
        handleUpdateSavedFilter,
        isUpdateFilterLoading,
    } = useAgreementStatusesSidebarFiltersContext();

    const [saveFiltersModalOpen, setSaveFiltersModalOpen] = useState(false);

    const handleOpenSaveFiltersModal = (savedFilterData: ICreateSavedFilter | null) => {
        setSaveFiltersModalOpen(true);
        handleSavedFilterSelect(savedFilterData);
    };

    const handleCancelSaveFilters = () => {
        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    const handleSaveFilters = async (filterData: ICreateSavedFilter) => {
        const upsertSavedFilter = filterData.id ? handleUpdateSavedFilter : handleCreateSavedFilter;

        await upsertSavedFilter(filterData);

        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    return (
        <>
            <SidebarWrapper
                collapsed={collapsed}
                onCollapseChange={onCollapseChange}
                collapsedWidth={AGREEMENT_STATUSES_PAGE_CONST.collapsedWidth}
                expandedWidth={AGREEMENT_STATUSES_PAGE_CONST.expandedWidth}
            >
                <Layout.Content
                    style={{
                        padding: 0,
                        margin: 0,
                        height: '100%',
                    }}
                >
                    {!collapsed && (
                        <div style={{ padding: '14px 12px 8px' }}>
                            <Typography.Text>Total Records: {totalRecords}</Typography.Text>
                        </div>
                    )}
                    <SidebarFiltersGroupCollapse collapsed={collapsed} setCollapsed={onCollapseChange} selectedItemsCount={0} />

                    {!collapsed && (
                        <AgreementStatusesSidebarTabs
                            onFilterChange={onFilterChange}
                            onOpenSaveFiltersModal={handleOpenSaveFiltersModal}
                            gridComponent={gridComponent}
                        />
                    )}
                </Layout.Content>
            </SidebarWrapper>

            {/* Modals goes here === */}
            {saveFiltersModalOpen && selectedSavedFilter && (
                <SaveAgreementStatusesFiltersModal
                    isLoading={isCreateFilterLoading || isUpdateFilterLoading}
                    initialSavedFilter={selectedSavedFilter}
                    onCancel={handleCancelSaveFilters}
                    onSave={handleSaveFilters}
                />
            )}
        </>
    );
};
